import { useI18n } from './I18nProvider';

/**
 * The reader's word for a role, from its key.
 *
 * Every role is a system role with a `role.<key>` string in the catalogue, so the label follows the reader's
 * language. A key the catalogue does not know gives nothing, never the raw key: "teacher" in the middle of
 * an Arabic sentence reads as a fault.
 */
export function useRoleLabel(): (roleKey: string | null | undefined) => string | null {
  const { t, has } = useI18n();
  return (roleKey) => (roleKey && has(`role.${roleKey}`) ? t(`role.${roleKey}`) : null);
}

/**
 * The role of someone listed to write to, in the reader's language: the catalogue's word for a known role, else the
 * nursery's own Arabic name for it, which has no other.
 */
export function useContactRole(): (contact: { roleKey: string | null; roleNameAr: string | null }) => string | null {
  const roleLabel = useRoleLabel();
  return (contact) => roleLabel(contact.roleKey) ?? contact.roleNameAr;
}
